import I18n from 'I18n';
import { useEffect, useState } from 'react';
import CosUsageModal from 'ContentComponents/components/modals/CosUsageModal';
import { getCtaLocations } from 'web-interactives-dashboard-ui/api/cosindex';
import { RenderWhen } from '../../utils/RenderWhen';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LocationsForValidId = ({
  interactiveId,
  lazyPreviewCount
}) => {
  var _locations$length;
  const [lastInteractiveId, setLastInteractiveId] = useState(interactiveId);
  const [locations, setLocations] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isRequestSent, setIsRequestSent] = useState(false);
  if (lastInteractiveId !== interactiveId) {
    setLastInteractiveId(interactiveId);
    setLocations(null);
    setIsError(false);
    setIsRequestSent(false);
  }
  const isDataMissing = locations == null;
  const locationCount = (_locations$length = locations === null || locations === void 0 ? void 0 : locations.length) !== null && _locations$length !== void 0 ? _locations$length : lazyPreviewCount;
  const isLocationCountMissing = locationCount == null;
  const mustRequestData = isDataMissing && (isLocationCountMissing || isModalOpen) && !isRequestSent;
  const [isLoading, setIsLoading] = useState(mustRequestData);
  useEffect(() => {
    if (!mustRequestData) {
      return;
    }
    setIsLoading(true);
    setIsRequestSent(true);
    getCtaLocations(interactiveId).then(response => {
      setLocations(response);
    }).catch(error => {
      console.error(error);
      setIsError(true);
    }).finally(() => {
      setIsLoading(false);
    });
  }, [interactiveId, mustRequestData]);
  if (isLocationCountMissing && isLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small"
    });
  }
  if (isLocationCountMissing) {
    return '-';
  }
  if (locationCount === 0) {
    return 0;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => setIsModalOpen(true),
      use: "transparent",
      padding: "0",
      children: locationCount
    }), /*#__PURE__*/_jsx(RenderWhen, {
      when: isModalOpen,
      children: /*#__PURE__*/_jsx(CosUsageModal, {
        contents: locations !== null && locations !== void 0 ? locations : [],
        isLoading: isLoading,
        onClose: () => setIsModalOpen(false),
        title: isError ? I18n.text('details.locations.error') : I18n.text('details.locations.title')
      })
    })]
  });
};
export const Locations = ({
  interactiveId,
  lazyPreviewCount
}) => {
  if (interactiveId <= 0) {
    return '-';
  }
  return /*#__PURE__*/_jsx(LocationsForValidId, {
    interactiveId: interactiveId,
    lazyPreviewCount: lazyPreviewCount
  });
};